import { render } from "./MaterialInput.vue?vue&type=template&id=1b912108&scoped=true"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import "./MaterialInput.vue?vue&type=style&index=0&id=1b912108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b912108"]])

export default __exports__